import React, { Component } from "react";
import logo from "../logoIPB.png";

export class Header extends Component {
  render() {
    return (
      <header>
        <div className="headerContainer">
          <img src={logo} alt="logotipoIPB" />
          <div>
            <a href="https://covid19.ipb.pt/en" target="_self" className="lang">
              EN
            </a>
            <h1>COVID-19</h1>
          </div>
        </div>
      </header>
    );
  }
}

export default Header;
